export const getTrackingId = (classes: string[], action: string | number) => {
  return `${classes.join(".")}.${action}`;
};
